<h4 class="title-bg">Lista de pasajeros</h4>
<h4 class="text-primary d-flex align-items-center mt-4"><img
        src="../assets/images/body/icons/icon-filter.svg" class="me-2"> Filtros</h4>
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="login form-pasajeros">
    <div class="row">
        <div class="col-md-6 mt-4">
            <div class="form-control p-0 position-relative d-flex align-items-center">
                <img src="../assets/images/body/icons/icon-person.svg"
                    class="position-absolute input-icon" height="20px">
                <input type="search" formControlName="search" class="w-100 border-secondary ps-5"
                    placeholder="Nombre y Apellido | DNI">
                <img src="../assets/images/body/icons/search-icon.svg"
                    class="position-absolute search-icon" alt="">
            </div>
        </div>
        <div class="col-md-3 mt-4">
            <div class="form-control p-0 position-relative d-flex align-items-center">
                <img src="../assets/images/body/icons/icon-location.svg"
                    class="position-absolute input-icon" height="20px">
                <input type="search" formControlName="destino" class="w-100 border-secondary ps-5" placeholder="Destino">
                <img src="../assets/images/body/icons/icon-agregar.svg"
                    class="position-absolute search-icon" width="40px">
            </div>
        </div>
        <div class="col-md-3 mt-4">
            <div class="form-control p-0 position-relative d-flex align-items-center">
                <input type="date" formControlName="fecha" class="w-100 border-secondary date ps-5"
                    placeholder="Fecha de viaje">
                <!-- <img src="../assets/images/body/icons/icon-fecha.svg"
                    class="position-absolute search-icon" width="40px"> -->
            </div>
        </div>
        <div class="col-12 mt-4">
            <div class="form-check form-check-inline">
                <input formControlName='sinpago' class="form-check-input" type="checkbox" id="inlineCheckbox3"
                    value="true">
                <label class="form-check-label" for="inlineCheckbox3">Sin pago</label>
            </div>
            <div class="form-check form-check-inline">
                <input formControlName='pagoparcial' class="form-check-input" type="checkbox" id="inlineCheckbox2"
                    value="true">
                <label class="form-check-label" for="inlineCheckbox2">Pago parcial</label>
            </div>
            <div class="form-check form-check-inline">
                <input formControlName='pagototal' class="form-check-input" type="checkbox" id="inlineCheckbox1"
                    value="true">
                <label class="form-check-label" for="inlineCheckbox1">Pago total</label>
            </div>
            <div class="d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
                <button class="btn rounded-pill btn-secondary">Buscar</button>
            </div>
        </div>
    </div>
</form>
<div class="row mt-5">

    <div class="col-6 d-flex justify-content-center justify-content-md-start">
        <div class="dropdown dropdown-custom">
            <button class="btn btn-primary rounded-pill dropdown-toggle" type="button"
                id="dropdownMenuButton1" data-toggle="dropdown" aria-expanded="false">
                Ordenar por: <span class="ms-2">A | Z</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="ordenarItems(this)">Ordenar por: Z | A</a></li>
            </ul>
        </div>
        <p class="contador-pasajeros ms-2 mb-0">Pasajeros: <span class="ms-2">{{ listPasajeros.length }}</span></p>
    </div>
    <div class="col-6 mt-md-0 mt-3 d-flex justify-content-center justify-content-md-end">
        <input id=excelfile type="file" accept=".xls,.xlsx" style="display: none" />
        <button class="btn btn-outline-file rounded-pill me-2" type="button" (click)="importExcel()">
            Importar
            <img src="../assets/images/body/icons/icon-importar.svg" width="20px" class="ms-2">
        </button>
        <button class="btn btn-outline-file rounded-pill" type="button" (click)="exportExcel()">
            Exportar
            <img src="../assets/images/body/icons/icon-exportar.svg" width="20px" class="ms-2">
        </button>
    </div>
</div>

<div class="row">

    <div class="col position-relative">
        <div class="table-responsive mt-3 mt-md-4">
            <table class="table custom-table">
                <thead>
                    <tr>
                        <th class="fit d-flex align-items-center" scope="col">
                            <img src="../assets/images/body/icons/icon-material-person.svg"
                                class="me-2">
                            Pasajero
                        </th>
                        <th class="fit" scope="col">DNI</th>
                        <th class="fit" scope="col">Fecha de Nacimiento</th>
                        <th class="fit" scope="col">Teléfono</th>
                        <th class="fit" scope="col">Correo</th>
                        <th class="fit" scope="col">Destino</th>
                        <th class="fit" scope="col">Fecha de viaje</th>
                        <th class="fit" scope="col">Cuenta</th>
                        <th class="fit" scope="col">Debe</th>
                        <th class="fit" scope="col">Pagó</th>
                        <th class="fit" scope="col">Precio Total</th>
                        <th class="edit-th" scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of pageOfItems" >
                        <td class="fit d-flex align-items-center">
                            <img src="../assets/images/body/icons/icon-person-table.svg" class="me-2">
                            {{ item.nombre_pasajero }}
                        </td>
                        <td class="fit">{{ formatoDocumento(item.numero_documento) }}</td>
                        <td class="fit">{{ formatoFecha(item.fecha_nacimiento) }}</td>
                        <td class="fit">{{ item.telefono_pasajero }}</td>
                        <td class="fit">{{ item.email_pasajero }}</td>
                        <td class="fit">{{ item.destino }}</td>
                        <td class="fit">{{ formatoFecha(item.fecha) }}</td>
                        <td class="fit">{{ statusPago(item) }}</td>
                        <td class="fit">{{ (item.costo_total > 0 ? item.costo_total: item.precio) - item.pagado }}</td>
                        <td class="fit">{{ item.pagado }}</td>
                        <td class="fit">{{ item.costo_total > 0 ? item.costo_total: item.precio }}</td>
                        <td class="edit">
                            <a (click)="openPasajerosDetalles(item)">
                                <svg id="Icon_awesome-edit" data-name="Icon awesome-edit" xmlns="http://www.w3.org/2000/svg" width="19.598" height="17.417" viewBox="0 0 19.598 17.417">
                                    <path id="Icon_awesome-edit-2" data-name="Icon awesome-edit" d="M13.7,2.834,16.767,5.9a.333.333,0,0,1,0,.47L9.336,13.8l-3.157.35a.662.662,0,0,1-.732-.732l.35-3.157,7.431-7.431A.333.333,0,0,1,13.7,2.834Zm5.512-.779L17.55.395a1.331,1.331,0,0,0-1.878,0l-1.2,1.2a.333.333,0,0,0,0,.47l3.069,3.069a.333.333,0,0,0,.47,0l1.2-1.2A1.331,1.331,0,0,0,19.21,2.055Zm-6.145,9.728v3.464H2.178V4.359H10a.418.418,0,0,0,.289-.119l1.361-1.361a.408.408,0,0,0-.289-.7H1.633A1.634,1.634,0,0,0,0,3.814V15.791a1.634,1.634,0,0,0,1.633,1.633H13.61a1.634,1.634,0,0,0,1.633-1.633V10.422a.409.409,0,0,0-.7-.289l-1.361,1.361A.418.418,0,0,0,13.066,11.783Z" transform="translate(0 -0.007)" fill="rgba(0,0,0,0.49)"/>
                                </svg>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<nav class="d-flex justify-content-center justify-content-md-end mt-4 paginacion">
  <jw-pagination [items]="listPasajeros" [pageSize]=10 (changePage)="onChangePage($event)"></jw-pagination>
</nav>
